import { render, staticRenderFns } from "./htmlElement.vue?vue&type=template&id=215b64d8&"
import script from "./htmlElement.vue?vue&type=script&lang=js&"
export * from "./htmlElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports